import { Calculation } from '@servicetitan/financing-api-client';
import { PrequalificationStatus } from '@servicetitan/financing-api-client/src/prequals-api';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface PrequalificationDecisionData {
    /** External prequalification ID from the provider */
    externalPrequalId?: string | null;
    /** Status of the prequalification */
    status: PrequalificationStatus;
    /** List of approved plans for this prequalification */
    approvedPlans?: Calculation[];
    /** Approved credit amount from the provider */
    approvedAmount?: number | null;
}

function usePrequalificationDecisionData(initialState: PrequalificationDecisionData) {
    const [prequalDecisionData, setPrequalDecisionData] = useState(initialState);

    return { prequalDecisionData, setPrequalDecisionData };
}

export const PrequalificationDecisionDataStore = createStore(usePrequalificationDecisionData);

export type PrequalificationDecisionDataStore = ReturnType<typeof usePrequalificationDecisionData>;
